/** Every synthesised track by name, compiled once on first use. Pure. */

import type { MusicTrack, MusicVariant } from '../types';
import { CAVE } from './cave';
import { compileSong } from './score';
import { COMPLETE, GAMEOVER, HISCORE } from './stings';
import { TITLE } from './title';
import type { Compiled, Song } from './types';

export const SONGS: Readonly<Record<MusicTrack, Song>> = {
  title: TITLE,
  hiscore: HISCORE,
  gameover: GAMEOVER,
  complete: COMPLETE,
  cave: CAVE,
};

const compiled = new Map<MusicTrack, Compiled>();

export function compiledSong(track: MusicTrack): Compiled {
  let c = compiled.get(track);
  if (!c) {
    c = compileSong(SONGS[track]);
    compiled.set(track, c);
  }
  return c;
}

/** How the synth plays a variant: semitones to transpose and a tempo factor. */
export interface Shift {
  readonly transpose: number;
  readonly tempo: number;
}

/** The Deep's cave groove sits a minor third lower and a touch slower; everything else as written. */
export function variantShift(track: MusicTrack, variant: MusicVariant | undefined): Shift {
  if (track === 'cave' && variant === 'deep') return { transpose: -3, tempo: 0.92 };
  return { transpose: 0, tempo: 1 };
}
